


























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PaginationPanel, DataPanel } from "@/components";
import SearchPanel from "@/components/SearchPanel.vue";
import { formRules, vform } from "@/common/util/validator";
import dayjs from 'dayjs';
import { Public } from "@/http/api_Public";
import { fmoney } from "@/common/util/money";
var fileDownload = require("js-file-download");
@Component({
  components: {
    SearchPanel,
    DataPanel,
    PaginationPanel,
  },
})
export default class memberRecharge extends Vue {

  fmoney = fmoney;
  timeValue = [dayjs(new Date()).startOf("month").format("YYYY-MM-DD"),dayjs(new Date()).endOf("month").format("YYYY-MM-DD")];
  /**登陆信息 */
  public userInfo = JSON.parse(localStorage.getItem("userInfo"));
  /**正则方法 */
  public formRules: any = formRules;
  /**请求加载判断 */
  public loading: boolean = false;
  // 右对齐
  public labelPosition: string = "right";
  /**刷新 */
  public rePagin: boolean = false;
  /**列表数据 */
  public listData = [];
  /**数据总数 */
  public total: number = 0;

  public $refs!: {
    form: HTMLFormElement;
  };
  exloading = false;
  // 搜索字段
  public searchValue = {
    shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
    phoneOrName: "",
    paymentMethod: null,
    startTime: dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
    endTime: dayjs(new Date()).endOf("month").format("YYYY-MM-DD") + " " + "23:59:59",
    skip: 0,
    count: 10,
    cashier:'',
  };
  payOptions2 = [
    {
      label: "全部",
      value: null,
    },
    {
      label: "现金",
      value: 2,
    },
    {
      label: "微信",
      value: 3,
    },
    {
      label: "支付宝",
      value: 4,
    },
    {
      label: "线下微信",
      value: 13,
    },
    {
      label: "线下支付宝",
      value: 14,
    },
  ];
  totalForm = {};
  async mounted() {
    await this.getlist();
  }
  activated() {}
  // beforeDestroy(){
  //     window.removeEventListener('handleEnter',this.handleSearch,false) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
  // }

  /**获取列表信息 */
  public async getlist() {
    this.loading = true;
    let result = await Public.GetMemberRechargeReport(this.searchValue);
    this.listData = result.items;
    this.total = result.totalCount;
    let result2 = await Public.GetMemberRechargeReportTotal(this.searchValue);
    this.totalForm = result2;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  // 点击搜索
  public async handleSearch() {
    this.rePagin = false;
    Object.assign(this.searchValue, { skip: 0, count: 10 });
    await this.getlist();
    this.rePagin = true;
  }
  // 重置
  public async onReset() {
    this.rePagin = false;
    this.timeValue = [dayjs(new Date()).startOf("month").format("YYYY-MM-DD"),dayjs(new Date()).endOf("month").format("YYYY-MM-DD")];
    this.searchValue = {
      shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
      phoneOrName: "",
      paymentMethod: null,
      startTime: dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
      endTime: dayjs(new Date()).endOf("month").format("YYYY-MM-DD") + " " + "23:59:59",
      skip: 0,
      count: 10,
      cashier:'',
    };
    await this.getlist();
    this.rePagin = true;
  }
  public async onPaginationChange(page) {
    let { skip, count } = page;
    Object.assign(this.searchValue, { skip, count });
    await this.getlist();
  }
  /**时间改变 */
  timeChange(val) {
    if (val) {
      this.searchValue.startTime = val[0] + " " + "00:00:00";
      this.searchValue.endTime = val[1]+ " " + "23:59:59";
    } else {
      this.searchValue.startTime = "";
      this.searchValue.endTime = "";
    }
  }
  getPayStatus2(val) {
    let str = "";
    str = this.payOptions2.find((v) => v.value == val).label;
    return str;
  }
  /**统计合计 */
  getSummaries(param) {
    const { columns, data } = param;
    const sums:any = [];
    let sumTotal = this.jsHj();

    columns.forEach((column, index) => {
        if (index === 0) {
            sums[index] = `合计`;
            return;
        }
        sums[index] = sumTotal[column.property];
    });

    return sums;
  }
  jsHj() {
    let form = {
        rechargeAmount: '',
        giftAmount: '',
    },
    arr = this.listData;
    if (arr.length > 0) {
        form = {
            rechargeAmount: fmoney(this.totalForm['rechargeAmount'],2),
            giftAmount:fmoney(this.totalForm['giftAmount'],2),
        };
    }
    return form;
  }
  export_table() {
    try {
      this.exloading = true;
      Public.GetMemberTradeOverviewReport(Object.assign({},this.searchValue,{
        skip:0,
        count:-1
      })).then((res) => {
        var fileName = "会员充值报表";
        fileDownload(res.data, fileName + ".xls");
        this.exloading = false;
      });
    } catch (error) {
      this.exloading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/memberRecharge/index.vue